module.exports = __webpack_public_path__ + "h5/img/bb5.d496be53.png";